import React from 'react';
import {
  GROUP_DELIVERY_METHOD,
  GROUP_MARKET_TYPES,
} from '@sonifi/wb-group/constants/wbGroupConstants';

const GuestRequest = ({ register, getValues }) => (
  <div className="row col-md-offset-1">
    <div className="row col-md-6">
      <label>
        Product Display Name:
        <input
          type="text"
          className="form-control"
          maxLength="30"
          {...register('products.guest_request.settings.display_name')}
        />
      </label>
      <br />
      <br />
      {getValues('group.market_type') !== GROUP_MARKET_TYPES.healthcare && (
        <div>
          <input
            className="form-control"
            type="checkbox"
            {...register(
              'products.guest_request.settings.display_category_images',
            )}
          />
          <label> Display Images for Categories </label>
        </div>
      )}

      <br />
      <br />
    </div>
    <div className="row col-md-6">
      <label>Delivery Method:</label>
      <br />
      {getValues('group.market_type') === GROUP_MARKET_TYPES.healthcare ? (
        <div className="row col-md-offset-1">
          <input
            id="on_site_fulfillment"
            type="radio"
            checked={true}
            onChange={() => false}
          />
          <label htmlFor="on_site_fulfillment" className="col-md-column-18">
            On-site Fulfillment
          </label>
        </div>
      ) : (
        <>
          <div className="row col-md-offset-1">
            <input
              id="integrated"
              type="radio"
              name="delivery-method"
              value="integrated"
              {...register('products.guest_request.settings.delivery_method')}
            />
            <label htmlFor="integrated" className="col-md-column-18">
              Integrated
            </label>
          </div>
          <div className="row col-md-offset-1">
            <input
              id="email_ordering"
              type="radio"
              name="delivery-method"
              value="email"
              {...register('products.guest_request.settings.delivery_method')}
            />
            <label htmlFor="email_ordering" className="col-md-column-18">
              Email
            </label>
          </div>
        </>
      )}
      {getValues('products.guest_request.settings.delivery_method') ===
        GROUP_DELIVERY_METHOD.integrated &&
      getValues('group.market_type') !== GROUP_MARKET_TYPES.healthcare ? (
        <div className="row col-md-offset-1">
          <br />
          <input
            className="form-control"
            type="checkbox"
            {...register('products.guest_request.settings.synchronizes')}
          />
          <label className="col-md-column-18">
            Structure Synchronizes with Integrator
          </label>
          <br />
          <br />

          <select
            defaultValue={getValues(
              'products.guest_request.settings.synchronization_delay',
            )}
            disabled={
              !getValues('products.guest_request.settings.synchronizes')
            }
            {...register(
              'products.guest_request.settings.synchronization_delay',
            )}
          >
            <option value="6">6 Hours</option>
            <option value="12">12 Hours</option>
            <option value="24">24 Hours</option>
            <option value="72">72 Hours</option>
            <option value="168">168 Hours</option>
          </select>
          <label className="col-md-column-18"> Between Synchronize Runs</label>
        </div>
      ) : null}

      {getValues('group.market_type') === GROUP_MARKET_TYPES.healthcare ? (
        <div className="row col-md-offset-1">
          <br />
          <input
            id="order_option"
            type="checkbox"
            className="form-control"
            {...register('products.guest_request.settings.order_by_option')}
          />
          <label htmlFor="order_option" className="col-md-column-18">
            Order by Option
          </label>
        </div>
      ) : null}

      <br />
    </div>
  </div>
);

export default GuestRequest;
